var _circle, _circle2, _circle3, _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiversity = function SvgDiversity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 29.5,
    r: 6.5,
    fill: "#FFD2A8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 63.5,
    r: 5.5,
    fill: "#6C9BF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 41,
    r: 9,
    fill: "#FF9D43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 23,
    y: 3,
    fill: "#2F68D1",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "m57.5 47 9.093 15.75H48.407z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.223,
    height: 6.223,
    x: 10.863,
    y: 18.4,
    fill: "#6C9BF1",
    rx: 2,
    transform: "rotate(45 10.863 18.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "M11.098 39.854c.599-1.843 3.205-1.843 3.804 0l.568 1.747a2 2 0 0 0 1.902 1.382h1.836c1.938 0 2.743 2.479 1.176 3.618l-1.486 1.08a2 2 0 0 0-.726 2.235l.567 1.747c.599 1.843-1.51 3.375-3.078 2.236l-1.485-1.08a2 2 0 0 0-2.352 0L10.34 53.9c-1.568 1.139-3.677-.393-3.078-2.236l.567-1.747a2 2 0 0 0-.726-2.236L5.616 46.6c-1.567-1.138-.762-3.617 1.176-3.617h1.836A2 2 0 0 0 10.53 41.6z"
  })));
};
export default SvgDiversity;